(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {

  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    if (!this.header) return;

    this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};

    this.setHeaderHeight();

    this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.predictiveSearches = this.querySelectorAll('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);

    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    if (!this.header) return;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  disconnectedCallback() {
    this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) {
      return;
    }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

      this.header.classList.add('scrolled-past-header');

      if (this.preventHide) return;

      requestAnimationFrame(this.hide.bind(this));

    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {

        requestAnimationFrame(this.reveal.bind(this));

      } else {

        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }

    } else if (scrollTop <= this.headerBounds.top) {

      this.header.classList.remove('scrolled-past-header');

      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');

    this.searchModals.forEach((searchModal) => {
      if (typeof searchModal.close === 'function') {
        searchModal.close(false);
      }
    });
  }

}


document.addEventListener(
  'open',
  (event) => {

    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) {
      return;
    }

    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));

    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);

  },
  true
);


if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}


/* ==========================================================
   AEA AJAX ADD TO BAG
   - stays on current page, no /cart redirect, no auto drawer
   - bottom right notification (5 seconds), cart count updated
   ========================================================== */

(function () {

  if (window.AEA_AJAX_CART_INITIALIZED) {
    return;
  }

  window.AEA_AJAX_CART_INITIALIZED = true;

  let notificationTimer = null;
  let loadingTimer = null;
  let addInProgress = false;


  function getElements() {
    return {
      notification: document.getElementById('aea-added-notification'),
      productName: document.getElementById('aea-added-product-name'),
      closeButton: document.getElementById('aea-added-close'),
      loading: document.getElementById('aea-cart-loading')
    };
  }


  /* ---------- LOADING ---------- */

  function showLoading() {
    const elements = getElements();

    if (!elements.loading) return;

    clearTimeout(loadingTimer);

    elements.loading.classList.add('aea-loading-active');
    elements.loading.setAttribute('aria-hidden', 'false');

    loadingTimer = setTimeout(function () {
      hideLoading();
    }, 10000);
  }


  function hideLoading() {
    const elements = getElements();

    if (!elements.loading) return;

    clearTimeout(loadingTimer);

    elements.loading.classList.remove('aea-loading-active');
    elements.loading.setAttribute('aria-hidden', 'true');
  }


  /* ---------- PRODUCT NAME ---------- */

  function getProductName(form) {

    let name = '';

    if (form) {

      const productForm = form.closest('product-form');

      if (productForm) {

        const titleElement = productForm.querySelector(
          '.product__title, .product__title h1, h1, [data-product-title]'
        );

        if (titleElement) {
          name = titleElement.textContent.replace(/\s+/g, ' ').trim();
        }
      }
    }

    if (!name) {

      const pageTitle = document.querySelector(
        '.product__title h1, h1.product__title, .product__title'
      );

      if (pageTitle) {
        name = pageTitle.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    if (!name && form) {

      const productCard = form.closest('.card-wrapper, .card, product-card');

      if (productCard) {

        const cardTitle = productCard.querySelector(
          '.card__heading, .card__heading a, .full-unstyled-link'
        );

        if (cardTitle) {
          name = cardTitle.textContent.replace(/\s+/g, ' ').trim();
        }
      }
    }

    return name || 'Your fragrance';
  }


  /* ---------- NOTIFICATION HELPERS ---------- */

  function restartProgress(notification) {
    const progress = notification.querySelector('.aea-added-progress');

    if (progress) {
      progress.style.animation = 'none';
      void progress.offsetWidth;
      progress.style.animation = '';
    }
  }


  function hideNotification() {
    const elements = getElements();

    if (!elements.notification) return;

    clearTimeout(notificationTimer);

    elements.notification.classList.remove('aea-show');
  }


  /* ---------- SUCCESS NOTIFICATION (5 SECONDS) ---------- */

  function showNotification(productName) {

    const elements = getElements();

    if (!elements.notification) return;

    clearTimeout(notificationTimer);

    if (elements.productName) {
      elements.productName.textContent = productName || 'Your fragrance';
    }

    const label = elements.notification.querySelector('.aea-added-label');
    const subtitle = elements.notification.querySelector('.aea-added-subtitle');
    const check = elements.notification.querySelector('.aea-added-check');

    if (label) label.textContent = 'Added to Bag';
    if (subtitle) subtitle.textContent = 'Your selection has been added to your bag.';
    if (check) check.textContent = '✓';

    elements.notification.classList.remove('aea-show');

    restartProgress(elements.notification);

    requestAnimationFrame(function () {
      elements.notification.classList.add('aea-show');
    });

    notificationTimer = setTimeout(function () {
      elements.notification.classList.remove('aea-show');
    }, 5000);
  }


  /* ---------- ERROR NOTIFICATION ---------- */

  function showError(message) {

    const elements = getElements();

    if (!elements.notification) return;

    clearTimeout(notificationTimer);

    const label = elements.notification.querySelector('.aea-added-label');
    const title = elements.notification.querySelector('.aea-added-title');
    const subtitle = elements.notification.querySelector('.aea-added-subtitle');
    const check = elements.notification.querySelector('.aea-added-check');

    if (label) label.textContent = 'Unable to Add';
    if (title) title.textContent = 'Please try again';
    if (subtitle) subtitle.textContent = message || 'Something went wrong.';
    if (check) check.textContent = '!';

    elements.notification.classList.remove('aea-show');

    restartProgress(elements.notification);

    requestAnimationFrame(function () {
      elements.notification.classList.add('aea-show');
    });

    notificationTimer = setTimeout(function () {

      elements.notification.classList.remove('aea-show');

      if (label) label.textContent = 'Added to Bag';
      if (title) title.textContent = 'Your fragrance';
      if (subtitle) subtitle.textContent = 'Your selection has been added to your bag.';
      if (check) check.textContent = '✓';

    }, 5000);
  }


  /* ---------- UPDATE CART COUNT ---------- */

  async function updateCartCount() {

    try {

      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(`${root}cart.js`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();

      const cartIcons = document.querySelectorAll('#cart-icon-bubble');

      cartIcons.forEach(function (cartIcon) {

        let bubble = cartIcon.querySelector('.cart-count-bubble');

        if (cart.item_count <= 0) {
          if (bubble) bubble.remove();
          return;
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartIcon.appendChild(bubble);
        }

        let visibleCount = bubble.querySelector('[aria-hidden="true"]');

        if (!visibleCount) {
          visibleCount = document.createElement('span');
          visibleCount.setAttribute('aria-hidden', 'true');
          bubble.appendChild(visibleCount);
        }

        visibleCount.textContent = cart.item_count;

        let hiddenCount = bubble.querySelector('.visually-hidden');

        if (!hiddenCount) {
          hiddenCount = document.createElement('span');
          hiddenCount.className = 'visually-hidden';
          bubble.appendChild(hiddenCount);
        }

        hiddenCount.textContent = `Cart contains ${cart.item_count} items`;

      });

    } catch (error) {
      console.warn('AEA cart count update failed:', error);
    }
  }


  /* ---------- AJAX ADD TO CART ---------- */

  async function ajaxAddToCart(form) {

    if (addInProgress) return;
    if (!form) return;

    addInProgress = true;

    const productName = getProductName(form);
    const formData = new FormData(form);

    showLoading();

    try {

      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        credentials: 'same-origin'
      });

      let data = null;

      try {
        data = await response.json();
      } catch (jsonError) {
        data = null;
      }

      if (!response.ok) {

        let message = 'Unable to add this fragrance to your bag.';

        if (data && data.description) {
          message = data.description;
        }

        throw new Error(message);
      }

      hideLoading();

      await updateCartCount();

      showNotification(productName);

    } catch (error) {

      hideLoading();

      console.error('AEA Add to Bag Error:', error);

      showError(
        error && error.message
          ? error.message
          : 'Something went wrong. Please try again.'
      );

    } finally {
      addInProgress = false;
    }
  }


  /* ---------- ADD TO BAG INTERCEPTOR (capture phase) ---------- */

  window.addEventListener(
    'submit',
    function (event) {

      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';

      const isCartAddForm =
        action.includes('/cart/add') || form.matches('form[action*="/cart/add"]');

      if (!isCartAddForm) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (typeof form.reportValidity === 'function') {
        if (!form.reportValidity()) return;
      }

      ajaxAddToCart(form);

    },
    true
  );


  /* ---------- CLOSE NOTIFICATION ---------- */

  document.addEventListener('click', function (event) {

    const closeButton = event.target.closest('#aea-added-close');

    if (!closeButton) return;

    event.preventDefault();

    hideNotification();

  });


  /* ---------- GLOBAL AEA FUNCTIONS ---------- */

  window.AEAShowAddedNotification = showNotification;
  window.AEAHideAddedNotification = hideNotification;
  window.AEAShowCartLoading = showLoading;
  window.AEAHideCartLoading = hideLoading;

})();


/* ==========================================================
   AEA HEADER: scroll par shadow + accent line
   ========================================================== */

(function () {

  if (window.AEA_HEADER_SCROLL_INITIALIZED) return;

  window.AEA_HEADER_SCROLL_INITIALIZED = true;

  let ticking = false;

  function update() {
    const wrapper = document.querySelector('.header-wrapper');

    if (wrapper) {
      wrapper.classList.toggle('aea-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 8);
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  update();

})();


  } catch(e) { console.error(e); }
})();
})();
